/**
 * Initialize all videos on the site.
 */

const players = Plyr.setup('.plyr-video');
// console.log('players', players);

// players[0].on( 'playing', event => {
// 	console.log('playing', event);
// });

let hasBeenFired = [];
let hasBeenEnded = [];

if ( players ) {

	for (let i = 0; i < players.length; i++ ) {

		hasBeenFired.push(false);

		// Change the homepage video poster when the instance is ready.
		// players[i].on( 'ready', event => {
		// 	if ( event.detail.plyr.elements.container.id === 'featured-video' ) {
		// 		players[i].poster = `https://${window.location.hostname}/wp-content/themes/Volum8WP/assets/images/video-contributor-poster.jpg`;
		// 	} else {
		// 		console.log( 'test', event.detail.plyr.elements.container.id );
		// 		const container = document.getElementById( event.detail.plyr.elements.container.id );
		// 		if ( container.getAttribute( 'data-poster' ) !== '' ) {
		// 			const posterURL = container.getAttribute( 'data-poster' );
		// 			players[i].poster = posterURL;
		// 		}
		// 	}
		// });

		players[i].on( 'playing', event => {
			if ( event.detail.plyr.elements.container.id === 'featured-video' && hasBeenFired[i] === false ) {
				gtag( 'event', 'homepage', {
					'event_category': 'homepage',
					'event_action': 'play',
					'event_label': 'compilation'
				});
				// console.log('its the homepage video');
				hasBeenFired[i] = true;
			} else if ( hasBeenFired[i] === false ) {
				// console.log('its a story video');
				const embed = document.getElementById( event.detail.plyr.media.id );
				const currentStory = embed.closest( 'article' ).id;
				const eventAction = currentStory.id;
				let path = window.location.pathname;
				path = path.substring( 1, path.length - 1 );
				gtag( 'event', path, {
					'event_category': path,
					'event_action': currentStory,
					'event_label':  'play'
				});
				// console.log('path', path);
				// console.log('currentStory', currentStory);
				hasBeenFired[i] = true;
				// Get story video.
			}
		});

		hasBeenEnded.push(false);

		players[i].on( 'ended', event => {
			if ( event.detail.plyr.elements.container.id === 'featured-video' && hasBeenEnded[i] === false ) {
				gtag( 'event', 'homepage', {
					'event_category': 'homepage',
					'event_action': 'completion',
					'event_label': 'compilation'
				});
				// console.log('its the homepage video completed');
				players[i].stop();
				hasBeenEnded[i] = true;
			} else if ( hasBeenEnded[i] === false ) {
				// console.log('its a story video');
				players[i].stop();
				const embed = document.getElementById( event.detail.plyr.media.id );
				const currentStory = embed.closest( 'article' ).id;
				const eventAction = currentStory.id;
				let path = window.location.pathname;
				path = path.substring( 1, path.length - 1 );
				gtag( 'event', path, {
					'event_category': path,
					'event_action': currentStory,
					'event_label':  'completion'
				});
				// console.log('path', path);
				// console.log('currentStory', currentStory);
				hasBeenFired[i] = true;
			}
		});
	}

}

// players.forEach( player => {
// 	player.on( 'playing', event => {
// 		console.log('playing', event);
// 	});
// })
